// partners.js
import React, { useState } from "react";
import FieldIcon from "../../utils/Register/field_icon";
import { useSelector } from "react-redux";

const PartnerPopUp = ({ onClose, onAddPartner }) => {
  const [partnerName, setPartnerName] = useState("");
  const [review, setReview] = useState("");
  const [image, setImage] = useState(null);

  const token = useSelector((state) => state.user.token);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("name", partnerName);
    formData.append("review", review);
    formData.append("partner_image", image);

    try {
      const response = await fetch(
        "https://server-postgre.vercel.app/api/partners",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Error al guardar el partner.");
      }

      const newPartner = await response.json();
      onAddPartner({
        id: newPartner.id,
        name: newPartner.name,
      }); // Notificamos al padre sobre el nuevo patrocinador

      onClose(); // Cerramos el popup
    } catch (error) {
      console.error("Error al conectar con el servidor:", error.message);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="w-[380px] bg-gradient-to-b from-orange-400 to-purple-500 p-6 rounded-3xl shadow-lg">
        <h2 className="text-center text-white text-lg font-bold mb-4">
          Nuevo Partner
        </h2>
        <div className="bg-gradient-to-b from-purple-500 to-purple-700 p-4 rounded-3xl shadow-inner">
          <form>
            <FieldIcon
              id="partnerName"
              name="partnerName"
              type="text"
              autoComplete="on"
              placeholder="Nombre del partner"
              value={partnerName}
              onChange={(e) => setPartnerName(e.target.value)}
              required
              label="Nombre*"
            />
            <FieldIcon
              id="review"
              name="review"
              type="text"
              autoComplete="on"
              placeholder="Opinión sobre el partner"
              value={review}
              onChange={(e) => setReview(e.target.value)}
              required
              label="Opinión*"
            />
            <div className="mt-4">
              <label className="block text-white text-sm font-bold mb-2">
                Imagen del partner*
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="w-full text-sm text-white file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:bg-blue-500 file:text-white hover:file:bg-blue-600"
              />
            </div>
          </form>
        </div>
        <div className="mt-4 text-center">
          <button
            onClick={handleSave}
            className="mt-2 bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
          >
            Guardar Partner
          </button>
        </div>
        <button
          onClick={onClose}
          className="mt-4 text-white text-sm underline hover:text-gray-300"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default PartnerPopUp;
